import { render, staticRenderFns } from "./ModalCorrectInputText.vue?vue&type=template&id=5add8c2f&scoped=true&lang=pug&"
import script from "./ModalCorrectInputText.vue?vue&type=script&lang=ts&"
export * from "./ModalCorrectInputText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5add8c2f",
  null
  
)

export default component.exports